<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li>
      <a>{{ company_name }}:</a>
    </li>
    <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item.page_ref)">
        {{ item.page_title }}
      </a>
    </li>
  </ul>
  <div class="right">
    <span>{{ today }}</span>
    <!--here responsiveness has been used commented by Prerna Singh on 21 february 2024-->
  </div>
</div>
<div class="tag_powered_by bottomPowerBy">
  <span>Powered by: <b>Enertics</b></span>
</div>

<div class="Content_outer">
  <div class="row">
    <div class="col-md-12">
      <div
        class="tab_right"
        style="
          width: 98%;
          z-index: 15;
          font-size: 14px;
          font-weight: 700;
          background-color: #f5f5f5;
          padding-top: 5px;
          margin: 0px;
          border: 1px solid #d8d8d8;
          margin-top: -6px;
        "
      >
        <div class="container">
          <div class="">
            <div class="legendbox legendBoxTop">
              <div style="background-color: #999999"></div>
              <strong>Offline</strong>
              <div style="background-color: #72ff13"></div>
              <strong>Healthy</strong>
              <div style="background-color: #faa700"></div>
              <strong>Unsatisfactory</strong>
              <div style="background-color: #ff2a1b"></div>
              <strong>Unacceptable</strong>
              <div style="background-color: #fcda42"></div>
              <strong>Out for service</strong>
            </div>
          </div>
        </div>
      </div>
      <div class="tab_right" *ngIf="connectivityType === 'wifi'">
        <div class="txt mainStatusWrap">
          <div class="valWrap">
            <span
              *ngIf="deviceStatus == 'Offline'"
              class="sprite_icon wifi_red"
            ></span>
            <span
              *ngIf="deviceStatus == 'Online'"
              class="sprite_icon wifi_black"
            ></span>
            <span class="un_seen"
              ><b>{{ deviceStatus }} </b>{{ latestFileTime }}</span
            >

            <span *ngIf="onoffStatus === 0" class="seen"
              ><b>Online</b>{{ overAllService }}</span
            >
            <span
              *ngIf="onoffStatus === 1 && isOutOfService == false"
              class="seen"
              ><b>Online</b>{{ overAllService }}</span
            >
          </div>
          <div class="statusWrap">
            <button
              class="float-end"
              *ngIf="serialNo != ''"
              style="float: right"
              class="settings-icon"
            >
              <img
                style="width: 20px; height: 20px; cursor: pointer"
                src="./assets/settings.png"
                [matMenuTriggerFor]="menu"
              />
            </button>

            <!-- <span *ngIf="onoffStatus === 0 && isOutOfService == false" class="seen">
              <img matTooltip="Asset Idle" style="height: 10px; width: 10px" src="./assets/images/red.png"
                [matTooltipClass]="'tooltip'" /></span>
            <span *ngIf="isOutOfService === true" class="seen" style="padding-left: 16px">
              <img matTooltip="Asset out for service" style="height: 10px; width: 10px" src="./assets/images/yellow.png"
                [matTooltipClass]="'tooltip'" /></span>

            <span *ngIf="onoffStatus === 1" class="seen">
              <img matTooltip="Asset Running" style="height: 10px; width: 10px" src="./assets/images/green.png"
                [matTooltipClass]="'tooltip'" />
            </span>
            <span class="seen">
              <img matTooltip="Asset Idle" style="height: 10px; width: 10px" src="./assets/images/red.png"
                [matTooltipClass]="'tooltip'" /></span> -->
          </div>
        </div>
        <mat-menu #menu="matMenu" class="stroked-menu">
          <div class="menu-item-container" *ngIf="userRoll != 'USER'">
            <button
              mat-stroked-button
              [disabled]="isOutOfService"
              (click)="viewJobList()"
              class="settings-button stroked-menu-button mb-2"
              [ngClass]="{ 'disabled-button': isOutOfService }"
            >
              Job Details
            </button>
            <button
              mat-stroked-button
              (click)="handlegetAllDoorCommentsModal()"
              class="settings-button stroked-menu-button"
            >
              Comments
            </button>
          </div>
          <!-- <div class="menu-item-container" *ngIf="userRoll != 'USER'">
          <button
            mat-stroked-button
            color="primary"
            [disabled]="isOutOfService"
            (click)="openCommentList()"
            class="edit-button stroked-menu-button"
            [ngClass]="{'disabled-button': isOutOfService}">
            <span>Comments List</span>
          </button>
        </div> -->
        </mat-menu>
      </div>
      <mat-menu #menu="matMenu">
        <button class="dropdown-item-btn">Plate Details</button>
        <a class="dropdown-item">Delete</a>
      </mat-menu>

      <div
        class="fixed_status_bar auto_padding"
        style="width: calc(100% - 33px); margin-bottom: 10px"
      >
        <div class="info_box_outer" style="margin-top: -3px">
          <div class="info_box">
            <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
              {{ company_name }}
            </h4>
            <ng-template #loading>
              <div class="skeleton skeleton-service-text-device-details"></div>
            </ng-template>
            <h6>Customer</h6>
          </div>
          <div class="info_box">
            <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
              {{ oven_extra_info.site_name }}
            </h4>
            <ng-template #loading>
              <div class="skeleton skeleton-service-text-device-details"></div>
            </ng-template>
            <h6>Site</h6>
          </div>
          <div class="info_box">
            <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
              {{ oven_extra_info.application_name }}
            </h4>
            <ng-template #loading>
              <div class="skeleton skeleton-service-text-device-details"></div>
            </ng-template>
            <h6>Application</h6>
          </div>
          <div class="info_box">
            <div class="inner">
              <div class="lft">
                <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
                  {{ "N/A" }}
                </h4>
                <ng-template #loading>
                  <div
                    class="skeleton skeleton-service-text-device-details"
                  ></div>
                </ng-template>
                <h6>Equipment Location</h6>
              </div>
              <div class="rgt" style="cursor: pointer">
                <img
                  alt="User"
                  class="thumb"
                  onerror="this.src='./assets/img-new/assets.png'"
                />
              </div>
            </div>
          </div>
          <div class="info_box">
            <h4 *ngIf="!monitoringDeviceDetailsLoader; else loading">
              {{ oven_extra_info.oven_name }}
            </h4>
            <ng-template #loading>
              <div class="skeleton skeleton-service-text-device-details"></div>
            </ng-template>
            <h6>Machine Serial Number</h6>
          </div>
        </div>
      </div>

      <div class="oven_gauge_box">
        <!------1st row-->
        <div class="chart_boxes_outer m_b_0 vibrationChartsView margin_setting">
          <div class="ch_box acc gauge_box min_height">
            <button
              class="float-end"
              *ngIf="serialNo != ''"
              style="float: right"
              (click)="openOvenThresholdSetting('temp_first_row')"
              class="border border-light settings-icon"
            >
              <img
                style="width: 20px; height: 20px; cursor: pointer"
                src="./assets/settings.png"
              />
            </button>
            <div class="heading">Temperature</div>
            <div class="inner vibrationInner" *ngIf="temperatureLoading">
              <div
                class="cht"
                *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]"
                style="margin-left: 50px"
              >
                <div class="skeleton skeleton-chart"></div>
                <div class="skeleton skeleton-chart-text"></div>
              </div>
            </div>
            <div class="inner vibrationInner" *ngIf="!temperatureLoading">
              <div
                class="cht"
                *ngFor="
                  let MonitoringMagacoustic of ovenParametersGuageData
                    | slice : 0 : 7
                "
                style="margin-left: 50px"
              >
                <app-gauge-chart
                  [canvasWidth]="160"
                  [canvasHeight]="140"
                  [needleValue]="MonitoringMagacoustic?.needleValue"
                  [centralLabel]="centralLabel"
                  [options]="MonitoringMagacoustic?.options"
                  [name]="MonitoringMagacoustic?.name"
                  [bottomLabel]="MonitoringMagacoustic?.bottomLabel"
                >
                </app-gauge-chart>
              </div>
            </div>
          </div>
        </div>

        <div class="chart_boxes_outer m_b_0 vibrationChartsView margin_setting">
          <div class="ch_box acc gauge_box min_height">
            <button
              class="float-end"
              *ngIf="serialNo != ''"
              style="float: right"
              (click)="openOvenThresholdSetting('temp_second_row')"
              class="border border-light settings-icon"
            >
              <img
                style="width: 20px; height: 20px; cursor: pointer"
                src="./assets/settings.png"
              />
            </button>
            <div class="heading">Temperature</div>
            <div class="inner vibrationInner" *ngIf="temperatureLoading">
              <div
                class="cht"
                *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]"
                style="margin-left: 50px"
              >
                <div class="skeleton skeleton-chart"></div>
                <div class="skeleton skeleton-chart-text"></div>
              </div>
            </div>
            <div class="inner vibrationInner" *ngIf="!temperatureLoading">
              <div
                class="cht"
                *ngFor="
                  let MonitoringMagacoustic of ovenParametersGuageData
                    | slice : 7 : 14
                "
                style="margin-left: 50px"
              >
                <app-gauge-chart
                  [canvasWidth]="160"
                  [canvasHeight]="140"
                  [needleValue]="MonitoringMagacoustic?.needleValue"
                  [centralLabel]="centralLabel"
                  [options]="MonitoringMagacoustic?.options"
                  [name]="MonitoringMagacoustic?.name"
                  [bottomLabel]="MonitoringMagacoustic?.bottomLabel"
                >
                </app-gauge-chart>
              </div>
            </div>
          </div>
        </div>

        <!---second row-->
        <div
          class="chart_boxes_outer m_b_0 vibrationChartsView"
          style="width: 100.23%; margin-left: -4px"
        >
          <app-oven-gauges style="display: flex; width: 100%"></app-oven-gauges>
        </div>

        <!--------3rd row-->
        <div
          class="chart_boxes_outer m_b_0 vibrationChartsView"
          style="width: 100.23%; margin-left: -4px"
        >
          <div style="width: 100.5%" class="d-flex justify-content-center">
            <div
              class="ch_box acc SEF_width d-flex justify-content-center min_height"
              style="text-align: center"
              style="width: 100%"
            >
              <app-oven-on-off-bar class="on-off-bar"></app-oven-on-off-bar>
            </div>
          </div>
          <!-- <div class="ch_box acc min_height" style="width: 32.7%">
            <app-oven-alert-summary></app-oven-alert-summary>
          </div> -->
          <!-- <div class="chartBoxWrap ch_box acc min_height" style="width: 32.7%">
            <app-oven-health-status></app-oven-health-status>
          </div> -->
        </div>

        <!------fourth row-->

        <div
          class="chart_boxes_outer m_b_0 vibrationChartsView"
          style="width: 100.23%; margin-left: -4px"
        >
          <div
            class="ch_box acc min_height"
            style="height: 360px; width: 65.5%"
          >
            <div class="heading d-flex justify-content-between">
              Job Details
              <button
                mat-raised-button
                color="primary"
                type="button"
                (click)="openJobForm()"
                [disabled]="filteredJobs.length>=4"
              >
                Add New Job
              </button>
            </div>
            <div class="search-container">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  (input)="onSearchInput($event)"
                  placeholder="Search by job number or supervisor..."
                />
              </div>
            </div>

            <div class="table-responsive" style="height: 243px">
              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Job No</th>
                    <th>Oven ID</th>
                    <th>Sensors</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Megger Value</th>
                    <th>PI Value</th>
                    <th>Sensor Serial 1</th>
                    <th>Sensor Serial 2</th>
                     <th>Sensor Serial 3</th>
                    <th>Supervisor</th>
                    <th>Actions</th>
                     <th>Records</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let job of filteredJobs">
                    <td>{{ job.JOB_NO }}</td>
                    <td>{{ job.oven_id }}</td>
                    <td>{{ job.no_of_sensor }}</td>
                    <td>{{ job.start_date | date : "yyyy-MM-dd HH:mm:ss" }}</td>
                    <td
                      [ngStyle]="{
                        'font-size': job.end_date ? 'inherit' : '30px'
                      }"
                    >
                      {{ job.end_date || "-" }}
                    </td>
                    <td>{{ job.megger_value }}</td>
                    <td>{{ job.PI_value }}</td>
                    <td>{{ job.sensor_serial_no_1 }}</td>
                    <td>{{ job.sensor_serial_no_2 }}</td>
                    <td>{{ job.sensor_serial_no_3 }}</td>
                    <td>{{ job.supervisor_name }}</td>
                    
                    <td>
                      <button
                        class="edit"
                        color="primary"
                        (click)="editJob(job.id)"
                        style="z-index: 9"
                      >
                        edit
                      </button>
                      <button
                        class="delete"
                        color="warn"
                        (click)="deleteJob(job.JOB_NO)"
                      >
                        delete
                      </button>
                    </td>
                    <td> <button
                mat-raised-button
                color="primary"
                type="button"
                (click)="openRecordsDialogueBox(job.JOB_NO)"
             
              >
                View
              </button></td>
                  </tr>
                  <tr *ngIf="filteredJobs.length === 0">
                    <td colspan="11" class="text-center">No jobs found</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="ch_box acc min_height" style="width: 24% ; height: 365px; overflow:auto">
            <div class="heading d-flex justify-content-between">
              Door Status
              <button
                mat-raised-button
                color="primary"
                type="button"
                (click)="addDoorComment(doorStatusList[0],'open')"
                [disabled]="disable_door_comment"
              >
                Update
              </button>
            </div>

            <div class="detail">
              @if(doorStatusList.length === 0){
              <p style="height: 200px; width: 100%;  display: flex; align-items: center; margin-left: 150px; font-weight: 700;">NO data available</p>
              }@else{ @for(item of doorStatusList; track item?.on_id) {
                <div class="row_col">
              <div class="left">Door Opening Time</div>
              <div class="right" style="display: flex; align-items: center; justify-content: center;">
                <button mat-icon-button 
                style="display: flex; align-items: center; justify-content: center;"
                (click)="handlegetAllDoorCommentsModal(item)" 
                aria-label="View Comments">
                <mat-icon>comment</mat-icon>
              </button>
              <span>
                {{ item.on_time | date:'yyyy-MM-dd HH:mm:ss'}}
              </span>
              </div>
            </div>

               
                <div class="row_col" *ngIf="item.off_time">
                  <div class="left">Door closing Time</div>
                  <div class="right">
                    <span>
                      {{ item.off_time | date:'yyyy-MM-dd HH:mm:ss'}}
                    </span>
                  </div>
                </div>
              } }
            </div>

            <!-- Status -->
          </div>
          <!-- <div class="ch_box acc min_height" style="width: 25%">
            <div class="heading d-flex justify-content-between">
              Operational
            </div>
            <div class="row"></div>

            <div class="row">
              <div class="col-sm-7 settxt">Oven Idle Time</div>
              <div class="col-sm settxt rateValue">
                <div *ngIf="monitoringMachineUtlizationLoader" class="skeleton skeleton-operational-text"></div>
                <span>
                  {{ "N/A" }}
                </span>
                {{ deviceStops }}
              </div>
            </div>
            <div class="row">
              <div class="col-sm-7 settxt">Oven Running Time</div>
              <div class="col-sm settxt rateValue">
                <div *ngIf="monitoringMachineUtlizationLoader" class="skeleton skeleton-operational-text"></div>
                <span>
                  {{ "N/A" }}
                </span>
                {{ deviceUtilization }}%
              </div>
            </div>
            <div class="row">
              <div class="col-sm-7 settxt">Fan Running Time</div>
              <div class="col-sm settxt rateValue">
                <div *ngIf="monitoringMachineUtlizationLoader" class="skeleton skeleton-operational-text"></div>
                <span>
                  {{ "N/A" }}
                </span>
                {{ deviceAverageRunTime }}
              </div>
            </div>
            <div class="row">
              <div class="col-sm-7 settxt">Heater Run Time</div>
              <div class="col-sm settxt rateValue">
                <div *ngIf="monitoringMachineUtlizationLoader" class="skeleton skeleton-operational-text"></div>
                <span>
                  {{ "N/A" }}
                </span>
                {{ deviceAverageRunTime }}
              </div>
            </div>
          </div> -->
          <div
            class="ch_box center"
            style="width: 10%"
            (click)="goToAdditionalParams()"
          >
            <img
              class="additional-img"
              src="./assets/arrow 1.png"
              alt=""
              style="width: 100%; height: 100%"
            />
            <button class="more-parameters">Trends</button>
          </div>
          <!-- job-details.component.html -->
        </div>
      </div>
    </div>
  </div>
</div>

<oven-door-comment-modal
      *ngIf="isAddingDoorComment"
      (onCancel)="handleDoorCommentModalCancel()"
      [isVisible]="isAddingDoorComment"
      [title]="'Door Operation Comment'"
      [doorData]="selectedDoorCommnet"
      >
</oven-door-comment-modal>

<door-open-comments-modal
  *ngIf="all_door_comments_modal"
  [isVisible]="all_door_comments_modal"
  [client_id]="clientId"
  [oven_id]="ovenId"
  [selected_door_id]="selected_oven_open_id"
  [comment_type]="selected_comment_type"
  (onCancel)="handlegetAllDoorCommentsModalCancel()">
</door-open-comments-modal>